<div class="content-block dx-card responsive-paddings ocl-bottom-container" style="width: 95vw !important;">
    <dx-toolbar height="54" style="padding-left: 16px; padding-right: 16px;" *ngIf="!isPhoneOrTablet">
        <dxi-item location="after">
            <dx-button
                text="Print Label"
                [disabled]="selectedItemsIds.length === 0"
                (click)="printLabels()"
            ></dx-button>
        </dxi-item>
        <dxi-item location="after">
            <dx-button
                text="Sign Requisitions"
                [disabled]="ButtonsDisabled || signedRequisitionSelected"
                (click)="signRequisitions()"
            ></dx-button>
        </dxi-item>
        <dxi-item location="after">
            <dx-button text="Email Forms" [disabled]="selectedItemsIds.length === 0 || !fusionAuthService.Profile" (onClick)="openEmailFax('email')"></dx-button>
        </dxi-item>
        <dxi-item location="after">
            <dx-button text="Fax Forms" [disabled]="selectedItemsIds.length === 0 || !fusionAuthService.Profile" (onClick)="openEmailFax('fax')"></dx-button>
        </dxi-item>
        <dxi-item location="after">
            <dx-button text="Update Bill To" [disabled]="selectedItemsIds.length === 0" (onClick)="openUpdateBillTo()"></dx-button>
        </dxi-item>
        <dxi-item location="after">
            <dx-button [disabled]="ButtonsDisabled" text="Print Requisitions" (click)="printRequisitions()"></dx-button>
        </dxi-item>
        <dxi-item location="after">
            <dx-button [disabled]="ButtonsDisabled" text="Print Log" (click)="printRequisitionLog()"></dx-button>
        </dxi-item>
    </dx-toolbar>
    <dx-data-grid
        #dxDataGridComponent
        [dataSource]="dataSource.value"
        [allowColumnReordering]="true"
        [allowColumnResizing]="true"
        [showRowLines]="true"
        [showBorders]="true"
        [highlightChanges]="true"
        [hoverStateEnabled]="true"
        [columnAutoWidth]="true"
        [wordWrapEnabled]="true"
        (selectedRowKeysChange)="itemsSelected($event)"
        height="60vh"
        style="min-width: 250px !important;"
        (onRowClick)="rowClick($event)"
        [columnHidingEnabled]="true">
        <dxo-scrolling mode="multiple"></dxo-scrolling>
        <dxo-pager
            [visible]="true"
            [allowedPageSizes]="[10, 20, 50, 100]"
            [showInfo]="true"
            [showNavigationButtons]="true"
            [showPageSizeSelector]="true"
        ></dxo-pager>
        <dxo-filter-row [showOperationChooser]="true" [visible]="true"></dxo-filter-row>
        <dxo-filter-panel [visible]="true"></dxo-filter-panel>
        <dxo-selection mode="multiple" showCheckBoxesMode="always" selectAllMode="page"></dxo-selection>
        <dxo-sorting mode="multiple"></dxo-sorting>
        <dxo-remote-operations
            [filtering]="true"
            [sorting]="true"
            [paging]="true"
            [groupPaging]="true"
            [grouping]="true"
        ></dxo-remote-operations>

        <dxi-column dataField="id" [visible]="false" [showInColumnChooser]="false" [showEditorAlways]="false"
                    [showWhenGrouped]="false" [allowFiltering]="false" sortIndex="1" sortOrder="desc"></dxi-column>
        <dxi-column caption="Requisition Id" dataField="code" [hidingPriority]="10" [minWidth]="80"></dxi-column>
        <dxi-column caption="Collection Date" dataField="collectionDate" dataType="date" [hidingPriority]="5"></dxi-column>
        <dxi-column cssClass="wrappedColumnClass" caption="Last name" dataField="patientLastName" [hidingPriority]="9" [minWidth]="60"></dxi-column>
        <dxi-column cssClass="wrappedColumnClass" caption="First name" dataField="patientFirstName" [hidingPriority]="8" [minWidth]="60"></dxi-column>
        <dxi-column caption="Birthdate" dataField="patientBirthDate" dataType="date" [hidingPriority]="4"></dxi-column>
        <dxi-column caption="Client" dataField="clientName" [hidingPriority]="7"></dxi-column>
        <dxi-column caption="Unit" dataField="unit" [hidingPriority]="3"></dxi-column>
        <dxi-column caption="Room - Bed" cellTemplate="roomCellTemplate" [hidingPriority]="2"></dxi-column>
        <dxi-column caption="Tests" cellTemplate="testsCellTemplate" [hidingPriority]="0"></dxi-column>
        <dxi-column caption="Signed" cellTemplate="signatureCellTemplate" cssClass="align-vertical-cell" alignment="center" [hidingPriority]="1"></dxi-column>
        <dxi-column caption="Status" cellTemplate="statusCellTemplate" cssClass="align-vertical-cell" [allowReordering]="false" [hidingPriority]="6"></dxi-column>
        <dxi-column cellTemplate="editTemplate" cssClass="align-vertical-cell"
            [allowReordering]="false" alignment="center" [width]="'30px'" [hidingPriority]="11" [visible]="isPhoneOrTablet">
        </dxi-column>

        <div *dxTemplate="let requisition of 'roomCellTemplate'">
            <span *ngIf="requisition.data.room && requisition.data.bed">{{requisition.data.room}} - {{requisition.data.bed}}</span>
            <span *ngIf="requisition.data.room || requisition.data.bed">{{requisition.data.room}}{{requisition.data.bed}}</span>
        </div>

        <div *dxTemplate="let requisition of 'signatureCellTemplate'">
            <div *ngIf="requisition.data.hasSignature" fxLayout="row" fxLayoutAlign="center">
                <dx-tooltip
                    target="#signature-{{ requisition.data.id }}"
                    showEvent="dxhoverstart"
                    hideEvent="dxhoverend"
                >
                    <div *dxTemplate="let data of 'content'">
                        <app-signature-viewer
                            [requisitionId]="requisition.data.id"
                        ></app-signature-viewer>
                    </div>
                </dx-tooltip>
                <div id="signature-{{ requisition.data.id }}" class="dx-icon-todo"></div>
            </div>
        </div>

        <div *dxTemplate="let requisition of 'testsCellTemplate'">
            {{ requisition.data.tests?.join(', ') }}
        </div>

        <div *dxTemplate="let requisition of 'statusCellTemplate'">
            <div fxLayout="row" fxLayoutAlign="center center" [innerHTML]="getStatus(requisition.data)"></div>
        </div>

        <div *dxTemplate="let requisition of 'editTemplate'">
            <div fxLayout="row" fxLayoutAlign="center center" style="cursor: pointer;">
                <i class="fa fa-eye" title="Edit" (click)="sendToPreview(requisition.data.id)"></i>
            </div>
        </div>
    </dx-data-grid>
    <dx-speed-dial-action
        *ngIf="FABDisabled"
        icon="fa fa-barcode"
        label="Print Label"
        [index]="1"
        (onClick)="printLabels()">
    </dx-speed-dial-action>
    <dx-speed-dial-action
        *ngIf="FABDisabled"
        icon="message"
        label="Email Forms"
        [index]="2"
        (onClick)="openEmailFax('email')">
    </dx-speed-dial-action>
    <dx-speed-dial-action
        *ngIf="FABDisabled"
        icon="message"
        label="Fax Forms"
        [index]="3"
        (onClick)="openEmailFax('fax')">
    </dx-speed-dial-action>
    <dx-speed-dial-action
        *ngIf="FABDisabled"
        icon="print"
        label="Print Requisitions"
        [index]="4"
        (onClick)="printRequisitions()">
    </dx-speed-dial-action>
    <dx-speed-dial-action
        *ngIf="FABDisabled"
        icon="export"
        label="Print Log"
        [index]="5"
        (onClick)="printRequisitionLog()">
    </dx-speed-dial-action>
    <dx-speed-dial-action
        *ngIf="FABDisabled"
        icon="background"
        label="Sign Requisitions"
        [index]="6"
        (onClick)="signRequisitions()">
    </dx-speed-dial-action>
</div>
<app-signature-dialog
    [popupVisible]="signRequisitionDialogVisible"
    (closeEvent)="signDialogClosed($event)"
></app-signature-dialog>

<app-email-fax-dialog
    [popupVisible]="emailFaxVisible"
    [type]="type"
    [ids]="selectedItemsIds"
    [from]="'requisition'"
    (closeEvent)="emailFaxVisible = false">
</app-email-fax-dialog>

<app-update-bill-to
    [popupVisible]="updateBillToVisible"
    [ids]="selectedItemsIds"
    [from]="'requisition'"
    (closeEvent)="closeUpdateBillTo()">
</app-update-bill-to>

<app-printer-dialog-multiple
    [popupVisible]="printDialogVisible"
    [requisitionIds]="selectedItemsIds"
    (closeEvent)="printDialogVisible = false">
</app-printer-dialog-multiple>
